
import {
    GET_ALL_TENANTS
   } from "../../constant/ActionType";
   
   export default function AllDataTenantsReduc(state = {
       getAllTenants: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_TENANTS:
               return {
                   ...state,
                   getAllTenants: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }